import type { IntlShape } from 'react-intl'

export const getManageTabs = (intl: IntlShape) => {
  return [
    {
      id: 'features-manage-insights',
      label: intl.formatMessage({
        id: 'features.manage.tab1',
        defaultMessage: 'Leverage insights',
      }),
      imageSrc:
        'https://cdn.sanity.io/images/dnsgqii5/production/cdb19b33a968c0205e7e928f0487d60628d0e6a8-2232x840.webp',
    },
    {
      id: 'features-manage-slice',
      label: intl.formatMessage({
        id: 'features.manage.tab2',
        defaultMessage: 'Slice & dice docs',
      }),
      imageSrc:
        'https://cdn.sanity.io/images/dnsgqii5/production/469ff3d3947d72f4bddd185753d8e44d6c248a15-2232x840.webp',
    },
    {
      id: 'features-manage-scale',
      label: intl.formatMessage({
        id: 'features.manage.tab3',
        defaultMessage: 'Manage at scale',
      }),
      imageSrc:
        'https://cdn.sanity.io/images/dnsgqii5/production/bcf8bc6f8505a681997ce4aad16191840477d4ff-2232x840.webp',
    },
  ]
}
